import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Router } from '@angular/router';
import { ReportResponseService } from '../../services/report_response.service';

@Component({
  selector: 'app-report-review',
  templateUrl: './report-review.component.html',
  styleUrl: './report-review.component.scss'
})
export class ReportReviewComponent {
  activeTab: string = 'tab1';
  isRContainersVisible = false; // Controla la visibilidad del contenedor izquierdo

  constructor(
    private route: ActivatedRoute,
    private router:Router,
    private ReportResponseService: ReportResponseService
  ){}

  ngOnInit(): void {
    this.ReportResponseService.dataToEdit$.subscribe(data=>{
      if(data){
        this.changeTab('tab2')
      }
    })
    this.route.paramMap.subscribe(params => {
      const id = params.get('id');
      if (id) {
        this.ReportResponseService.setSelectedReportResponseId(id); // Establecer el ID del reporte seleccionado y en list-concepts se carga
        
      } else {
        console.warn('No se recibió ningún ID en la ruta');
        //this.router.navigate(['/expense-reports/reports-review']); // fallback
      }
    });
  }
  toggleRContainers(): void {
    this.isRContainersVisible = !this.isRContainersVisible;
  }

  routingTo(route:string){
    this.router.navigate(['expense-reports/'+route]);
  }

  changeTab(tabId: string): void {
    this.activeTab = tabId;
  }
  
}
